import { render, staticRenderFns } from "./SidebarCartItemConfigurable.vue?vue&type=template&id=561cbb6d&"
import script from "./SidebarCartItemConfigurable.vue?vue&type=script&lang=js&"
export * from "./SidebarCartItemConfigurable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561cbb6d')) {
      api.createRecord('561cbb6d', component.options)
    } else {
      api.reload('561cbb6d', component.options)
    }
    module.hot.accept("./SidebarCartItemConfigurable.vue?vue&type=template&id=561cbb6d&", function () {
      api.rerender('561cbb6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/SidebarCartItemConfigurable.vue"
export default component.exports